module.exports = __webpack_public_path__ + "img/part_an_1.ebc07b89.png";